/**
 * 字体大小切换，目前只用到报纸渠道
 * created by lzy 2020.05.13
 */

'use strict';
angular.module('fontSizeSwitchingModule', []).directive('fontSizeSwitching', ['localStorageService', '$sessionStorage',
    function(localStorageService, $sessionStorage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: './editingCenter/directive/fontSizeSwitching/fontSizeSwitching.html',
            scope: {
                switchMode: '=', // 字体大小模式
                callback: '&' // 点击之后的回调函数
            },
            link: function($scope, isElement, attrs) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.switchMode = '18';
                    $scope.data = {
                        curUserId: $sessionStorage.get('curUserInfo').ID,
                        userFont: localStorageService.get('userFont') || {}
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    getFontSize();
                }

                /**
                 * [getFontSize description] 获取字体大小，当用户修改后会存到localstorage中，报纸渠道全局生效
                 *
                 * @return  {[type]}  [return description]
                 */
                function getFontSize() {
                    if ($scope.data.userFont[$scope.data.curUserId]) {
                        $scope.switchMode = $scope.data.userFont[$scope.data.curUserId];
                    }
                }

                /**
                 * [changeFontSize description] 切换字体
                 *
                 * @param   {[type]}  size  [size description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.changeFontSize = function(size) {
                    if (size !== $scope.switchMode) {
                        $scope.switchMode = size;
                        $scope.data.userFont[$scope.data.curUserId] = size;
                        localStorageService.set('userFont', $scope.data.userFont);
                    }
                };
            }
        };
    }
]);
